/**
 * Finds two numbers in the given array that add up to 10 (mod 10).
 * @param {number[]} numbers - The array of numbers to search.
 * @returns {number[]} An array of two numbers that add up to 10 (mod 10), or an empty array if none are found.
 */
function findTwo10ModNumbers(numbers) {
    var numDict = {};
    for (var i = 0; i < numbers.length; i++) {
      var num = numbers[i];
      if (num in numDict) {
        return [num, 10 - num];
      } else {
        numDict[10 - num] = num;
      }
    }
}
    
  
  function checkNumbers(num1, num2, arr) {
    // Check if num1 is present in the array
    const num1Exists = arr.includes(num1);
  
    // Check if num2 is present in the array
    const num2Exists = arr.includes(num2);
  
    // Return true if either num1 or num2 is present in the array, otherwise return false
    return num1Exists || num2Exists;
  }
  
    // Function to find the missing numbers in the subset from the master list
  // function findMissingNumbers(master, subset) {
  //   // Convert master list to a Set
  //   let masterSet = new Set(master);
  //   // Convert subset list to a Set
  //   let subsetSet = new Set(subset);
  //   // Find missing numbers
  //   return Array.from(masterSet).filter(num => !subsetSet.has(num));
  // }
  
    /**
   * Find pairs of numbers in the list that add up to a multiple of ten.
   * @param {number[]} numbers - The list of numbers.
   * @returns {number[]} - The list of pairs of numbers that add up to a multiple of ten.
   */
  function findMultiplesOfTen(numbers) {
    let result = [];
    for (let i = 0; i < numbers.length; i++) {
      for (let j = i + 1; j < numbers.length; j++) {
        if ((numbers[i] + numbers[j]) % 10 === 0) {
          result.push(numbers[i], numbers[j]);
        }
      }
    }
    console.log(result)
    return result;
  }
  
    function sumArrayElements(arr) {
    // Function to calculate the sum of elements in an array
    //
    // Args:
    //   arr: list of numbers
    //
    // Returns:
    //   sum of all elements in the array
    return arr.reduce((accumulator, currentValue) => {
      return accumulator + currentValue;
    }, 0);
  }
  
  /**
 * Find the missing numbers in the subset from the master list.
 *
 * @param {Array} master - The master list of numbers.
 * @param {Array} subset - The subset of numbers.
 * @returns {Array} - The list of numbers that are in the master list but not in the subset.
 */
function findMissingNumbers(master, subset) {
  // Convert master array to a set
  const masterSet = new Set(master);

  // Convert subset array to a set
  const subsetSet = new Set(subset);

  // Find missing numbers
  const missingNumbers = [...masterSet].filter(num => !subsetSet.has(num));

  return missingNumbers;
}


  export{sumArrayElements,findMultiplesOfTen,findMissingNumbers,}